<template>
  <footer class="page-footer bg-dark" role="contentinfo">
    <div class="d-flex align-items-center flex-1 text-muted">
      <span class="hidden-md-down fw-700">
        {{ version }} {{ buildDate | moment("YYYY") }} &copy; {{appTitle}} by&nbsp;
        <a
          href="https://witkac.pl"
          class="text-primary fw-500"
          target="_blank"
        >Witkac sp. z o.o.</a>
      </span>
    </div>

    <div>
      <ul class="list-table m-0">
        <li>
          <a href="intel_introduction.html" class="text-secondary fw-700">About</a>
        </li>

        <li class="pl-3">
          <a href="info_app_licensing.html" class="text-secondary fw-700">License</a>
        </li>

        <li class="pl-3">
          <a href="info_app_docs.html" class="text-secondary fw-700">Documentation</a>
        </li>

        <li class="pl-3 fs-xl">
          <a href="https://wrapbootstrap.com/user/MyOrange" class="text-secondary" target="_blank">
            <i class="fal fa-question-circle" aria-hidden="true" />
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    copyYear() {
      return new Date().getFullYear();
    },
    ...mapState({
      version: state => state.system.packageVersion,
      appTitle: state => state.system.appTitle,
      buildDate: state => new Date(state.system.buildDate)
    })
  }
};
</script>
